import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\app\\tools\\tasks\\page.tsx");
